export const processInitialPosition = (data, container, targetClass) => {
  console.log("process initial position")
  const targetContainer = container.closest(targetClass);
  if (targetContainer) {
    const targetStyles = targetContainer.style;
    const dataStyles = data.tuneData;
    if (dataStyles.top !== '' && (dataStyles.top !== targetStyles.top)) {
      targetContainer.style.top = dataStyles.top;
    }
    if (dataStyles.left !== '' && (dataStyles.left !== targetStyles.left)) {
      targetContainer.style.left = dataStyles.left;
    }
    if (dataStyles.width !== '' && (dataStyles.width !== targetStyles.width)) {
      targetContainer.style.width = dataStyles.width;
    }
    if (dataStyles.height !== '' && (dataStyles.height !== targetStyles.height)) {
      targetContainer.style.height = dataStyles.height;
    }
  }
}

const safeMergeStyleData = (data, newStyleData) => {
  if (!data || !newStyleData) {
    console.warn('Invalid data provided to safeMergeStyleData');
    return newStyleData || {};
  }

  const currentStyles = data.tuneData || {};
  const mergedStyles = { ...newStyleData };

  const protectedAttributes = ['top', 'left', 'width', 'height'];

  protectedAttributes.forEach(attr => {
    const newValue = mergedStyles[attr];
    const currentValue = currentStyles[attr];

    // Only preserve if:
    // 1. New value is empty/undefined AND
    // 2. Current value exists and is not empty
    if (
      (newValue === '' || newValue === undefined || newValue === null) &&
      (currentValue !== undefined && currentValue !== '' && currentValue !== null)
    ) {
      mergedStyles[attr] = currentValue;
    }

  });

  return mergedStyles;
}

export const getDraggableData = (data, container, targetClass) => {
  const mediaElement = container.closest(targetClass);
  if(!mediaElement) return data;
  const style = mediaElement.style;
  const styleData = {
    top: style?.top,
    left: style?.left,
    width: style?.width,
    height: style?.height,
  }
  const dataWithTune = {
    ...data,
    tuneData: {
      ...safeMergeStyleData(data, styleData),
    }
  }
  return dataWithTune;
}
